import React, { useState, useEffect } from "react";
import axios from "axios";

export default function WeatherUvi(props) {
  const [ready, setReady] = useState(false);
  const [uvi, setUvi] = useState(null);
  useEffect(() => {
    setReady(false);
  }, [props.coordinates]);
  function HandleResponse(response) {
    console.log(response.data);
    setUvi(response.data.current.uvi);
    setReady(true);
  }
  if (ready) {
    return <span>{Math.round(uvi)} </span>;
  } else {
    let apiKey = "8161b4309ee03faae957729ba7104797";
    let longitude = props.coordinates.lon;
    let latitude = props.coordinates.lat;
    let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&units=metric&appid=${apiKey}`;
    axios.get(apiUrl).then(HandleResponse);
    return "uvi loading...";
  }
}
